import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams, Events } from "ionic-angular";
import { LoginPage } from "../login/login";
import { RegisterPage } from "../register/register";
import { AuthProvider } from "../../providers/auth/auth.provider";

/**
 * Generated class for the PresentationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-presentation",
  templateUrl: "presentation.html"
})
export class PresentationPage {
  errorMessage: string = "";

  constructor(
    public navCtrl: NavController,
    public authProvider: AuthProvider,
    public events: Events,
    public navParams: NavParams
  ) {}

  ionViewDidLoad() {
    console.log("ionViewDidLoad PresentationPage");
  }

  login() {
    this.navCtrl.push(LoginPage);
  }
  register() {
    this.navCtrl.push(RegisterPage);
  }

  tryFacebookLogin() {
    this.authProvider.doFacebookLogin().then(
      res => {
        this.events.publish("user:login");
      },
      err => {
        this.errorMessage = err.message;
      }
    );
  }

  tryGoogleLogin() {
    this.authProvider.doGoogleLogin().then(
      res => {
        this.events.publish("user:login");
      },
      err => {
        this.errorMessage = err.message;
      }
    );
  }

  tryTwitterLogin() {
    this.authProvider.doTwitterLogin().then(
      res => {
        this.events.publish("user:login");
      },
      err => {
        this.errorMessage = err.message;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/presentation/presentation.ts